import { SPage } from "src/components/spage";

interface IProps {}
export const ScheduleModulesPage = ({}: IProps) => {
  return <SPage title={"Schedule Modules"}></SPage>;
};
